export function lessonDayGroup(
  lessons: Array<{ date?: string | null }>,
  index: number,
): { firstOfDay: boolean; dayIndex: number; isDayBreak: boolean } {
  let dayIndex = 0
  for (let i = 1; i <= index; i++) {
    if ((lessons[i]?.date ?? '') !== (lessons[i - 1]?.date ?? '')) dayIndex++
  }
  const dateKey = lessons[index]?.date ?? ''
  const prevDate = index > 0 ? (lessons[index - 1]?.date ?? '') : null
  const firstOfDay = prevDate === null || prevDate !== dateKey
  return { firstOfDay, dayIndex, isDayBreak: firstOfDay && index > 0 }
}

export function lessonDayRowClass(dayIndex: number, isDayBreak: boolean): string {
  const wash = dayIndex % 2 === 1
    ? '[background-image:linear-gradient(rgba(248,250,252,0.45),rgba(248,250,252,0.45))] dark:[background-image:linear-gradient(rgba(15,23,42,0.18),rgba(15,23,42,0.18))]'
    : ''
  const br = isDayBreak ? 'border-t border-gray-200 dark:border-gray-600' : ''
  return [wash, br].filter(Boolean).join(' ')
}

export function lessonDayDateCellClass(dayIndex: number): string {
  return dayIndex % 2 === 1
    ? 'shadow-[inset_2px_0_0_#cbd5e1] dark:shadow-[inset_2px_0_0_#475569]'
    : 'shadow-[inset_2px_0_0_#e2e8f0] dark:shadow-[inset_2px_0_0_#334155]'
}
